
import React, { useState, useEffect } from 'react';
import { 
  Button, 
  Input, 
  Modal, 
  Form, 
  Spin, 
  Row, 
  Col, 
  Space, 
  Image,
  Upload,
  message,
  Card,
  Typography,
  ConfigProvider,
  Divider
} from 'antd';
import { 
  FaEdit, 
  FaImage,
  FaSave,
  FaBuilding
} from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api';

const { Dragger } = Upload;
const { Title, Text } = Typography;

const GerirEmpresa = () => {
  // Estados principais
  const [empresa, setEmpresa] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  
  // Estados para modal
  const [isModalVisible, setIsModalVisible] = useState(false);
  
  // Formulário
  const [form] = Form.useForm();
  const [imageUrl, setImageUrl] = useState('');

  // Cores do degradê
  const primaryColor = 'rgb(249, 130, 68)';
  const secondaryColor = 'rgb(247, 72, 115)';
  const gradient = `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`;

  // URL base para imagens
   /*
  const BASE_IMAGE_URL = 'http://127.0.0.1:8000/img/';
  const IMG_ALTERNATIVA = 'http://127.0.0.1:8000/img/default.png';
  */

 
  const BASE_IMAGE_URL = 'https://qrorder.technext.ao/public/img/';
  const IMG_ALTERNATIVA = 'https://qrorder.technext.ao/public/img/default.png';

  // Configuração do upload
  const uploadProps = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    beforeUpload: () => false,
    onChange: (info) => {
      const file = info.file;
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setImageUrl(e.target.result);
        };
        reader.readAsDataURL(file);
        // Armazena o arquivo real no form
        form.setFieldsValue({ img: file });
      } else {
        message.error('Você só pode enviar arquivos de imagem!');
      }
    }
  };

  // Buscar dados da empresa
  useEffect(() => {
    fetchEmpresa();
  }, []);

    useEffect(() => {
     document.title = "Empresa";
   
  }, []);

  const fetchEmpresa = async () => {
    try {
      setLoading(true);
      const empresaData = await Api.ListEmpresa();
      
      // Como só tem uma empresa, pega a primeira (ou único) item do array
      const empresaFormatada = Array.isArray(empresaData) ? empresaData[0] : empresaData;
      
      if (empresaFormatada) {
        setEmpresa({
          ...empresaFormatada,
          img: empresaFormatada.img 
            ? (empresaFormatada.img.startsWith('http') 
                ? empresaFormatada.img 
                : `${BASE_IMAGE_URL}${empresaFormatada.img}`)
            : null
        });
      }
    } catch (error) {
      toast.error('Erro ao carregar dados da empresa: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Abrir modal de edição
  const handleEdit = () => {
    if (empresa) {
      form.setFieldsValue({
        nome: empresa.nome || '',
        nif: empresa.nif || '',
        endereco: empresa.endereco || '',
        telefone: empresa.telefone || '',
        email: empresa.email || '',
        site: empresa.site || '',
        img: empresa.img ? empresa.img.replace(BASE_IMAGE_URL, '') : ''
      });
      setImageUrl(empresa.img || '');
      setIsModalVisible(true);
    }
  };

  // Salvar dados da empresa
  const handleSubmit = async (values) => {
    try {
      setSaving(true);

      const formData = new FormData();
      formData.append('nome', values.nome);
      formData.append('nif', values.nif);
      formData.append('endereco', values.endereco);
      formData.append('telefone', values.telefone);
      formData.append('email', values.email);
      formData.append('site', values.site || '');

      // Adiciona o arquivo de imagem se existir
      if (values.img instanceof File) {
        formData.append('img', values.img);
      }

      // Adiciona o ID da empresa se existir
      if (empresa && empresa.id) {
        formData.append('id', empresa.id);
      }

      const response = await Api.AlterEmpresa(formData);
      
      if (response.success) {
        fetchEmpresa(); // Recarrega os dados atualizados
        toast.success('Dados da empresa atualizados com sucesso!');
        setIsModalVisible(false);
        form.resetFields();
        setImageUrl('');
      } else {
        toast.error(response.message || 'Erro ao atualizar dados da empresa');
      }
    } catch (error) {
      toast.error('Erro ao salvar dados: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: primaryColor,
          borderRadius: 8,
        },
      }}
    >
      <div style={{ 
        padding: 24,
        background: '#f8f9fa',
        minHeight: '100vh'
      }}>
        <ToastContainer position="top-right" />
        
        {/* Cabeçalho */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          marginBottom: 24,
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 16
        }}>
          <Title level={2} style={{ 
            margin: 0,
            background: gradient,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            DADOS DA EMPRESA
          </Title>
          
          <Button 
            type="primary"
            icon={<FaEdit />}
            onClick={handleEdit}
            disabled={!empresa}
            style={{ 
              background: gradient,
              border: 'none',
              borderRadius: 8,
              boxShadow: '0 4px 12px rgba(247, 72, 115, 0.3)',
              height: 40,
              display: 'flex',
              alignItems: 'center'
            }}
          >
            Editar Dados
          </Button>
        </div>

        {/* Card com dados da empresa */}
        <Spin spinning={loading}>
          {empresa ? (
            <Card
              style={{
                borderRadius: 12,
                border: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                maxWidth: 1000,
                margin: '0 auto'
              }}
            >
              <Row gutter={32}>
                {/* Coluna da imagem */}
                <Col xs={24} md={8}>
                  <div style={{ textAlign: 'center' }}>
                    <Image
                      src={empresa.img || IMG_ALTERNATIVA}
                      fallback={IMG_ALTERNATIVA}
                      alt={empresa.nome}
                      style={{
                        width: '100%',
                        maxWidth: 250,
                        height: 200,
                        objectFit: 'contain',
                        borderRadius: 8,
                        border: '1px solid rgba(0,0,0,0.1)'
                      }}
                      preview={false}
                    />
                    <div style={{ marginTop: 16 }}>
                      <FaBuilding style={{ 
                        fontSize: 48, 
                        color: primaryColor,
                        opacity: 0.7
                      }} />
                    </div>
                  </div>
                </Col>

                {/* Coluna dos dados */}
                <Col xs={24} md={16}>
                  <div style={{ padding: '16px 0' }}>
                    <Title level={3} style={{ 
                      marginBottom: 24,
                      color: '#333',
                      borderBottom: `2px solid ${primaryColor}`,
                      paddingBottom: 8
                    }}>
                      {empresa.nome}
                    </Title>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Text strong>NIF:</Text>
                        <div style={{ marginTop: 4 }}>
                          {empresa.nif || <Text type="secondary">Não informado</Text>}
                        </div>
                      </Col>

                      <Col span={12}>
                        <Text strong>Telefone:</Text>
                        <div style={{ marginTop: 4 }}>
                          {empresa.telefone || <Text type="secondary">Não informado</Text>}
                        </div>
                      </Col>

                      <Col span={24}>
                        <Text strong>Endereço:</Text>
                        <div style={{ marginTop: 4 }}>
                          {empresa.endereco || <Text type="secondary">Não informado</Text>}
                        </div>
                      </Col>

                      <Col span={12}>
                        <Text strong>E-mail:</Text>
                        <div style={{ marginTop: 4 }}>
                          {empresa.email || <Text type="secondary">Não informado</Text>}
                        </div>
                      </Col>

                      <Col span={12}>
                        <Text strong>Site:</Text>
                        <div style={{ marginTop: 4 }}>
                          {empresa.site ? (
                            <a 
                              href={empresa.site.startsWith('http') ? empresa.site : `https://${empresa.site}`}
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{ color: primaryColor }}
                            >
                              {empresa.site}
                            </a>
                          ) : (
                            <Text type="secondary">Não informado</Text>
                          )}
                        </div>
                      </Col>
                    </Row>

                    <Divider />

                    <Text type="secondary" style={{ fontSize: 12 }}>
                      Última atualização: {new Date().toLocaleDateString('pt-BR')}
                    </Text>
                  </div>
                </Col>
              </Row>
            </Card>
          ) : (
            !loading && (
              <Card
                style={{
                  borderRadius: 12,
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                  maxWidth: 600,
                  margin: '0 auto',
                  textAlign: 'center',
                  padding: 40
                }}
              >
                <FaBuilding style={{ 
                  fontSize: 64, 
                  color: primaryColor,
                  opacity: 0.5,
                  marginBottom: 16
                }} />
                <Title level={4} style={{ color: 'rgba(0,0,0,0.5)' }}>
                  Nenhuma empresa cadastrada
                </Title>
                <Text type="secondary">
                  Clique no botão "Editar Dados" para cadastrar as informações da sua empresa.
                </Text>
              </Card>
            )
          )}
        </Spin>

        {/* Modal de edição */}
        <Modal
          forceRender
          title={
            <span style={{
              background: gradient,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'inline-block'
            }}>
              {empresa ? 'Editar Dados da Empresa' : 'Cadastrar Empresa'}
            </span>
          }
          open={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false);
            setImageUrl('');
            form.resetFields();
          }}
          footer={[
            <Button 
              key="cancel" 
              onClick={() => {
                setIsModalVisible(false);
                setImageUrl('');
                form.resetFields();
              }}
              style={{ borderRadius: 6 }}
              disabled={saving}
            >
              Cancelar
            </Button>,
            <Button 
              key="submit" 
              type="primary" 
              loading={saving}
              onClick={() => form.submit()}
              icon={<FaSave />}
              style={{ 
                background: gradient,
                border: 'none',
                borderRadius: 6,
                boxShadow: '0 2px 8px rgba(247, 72, 115, 0.3)'
              }}
            >
              {saving ? 'Salvando...' : 'Salvar Alterações'}
            </Button>
          ]}
          width={700}
          destroyOnClose
          styles={{
            header: {
              borderBottom: '1px solid rgba(0,0,0,0.05)'
            },
            footer: {
              borderTop: '1px solid rgba(0,0,0,0.05)'
            }
          }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="nome"
                  label="Nome da Empresa"
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                >
                  <Input 
                    placeholder="Digite o nome da empresa"
                    maxLength={100}
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item>

                <Form.Item
                  name="nif"
                  label="NIF"
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                >
                  <Input 
                    placeholder="Digite o NIF"
                    maxLength={20}
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item>

                <Form.Item
                  name="telefone"
                  label="Telefone"
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                >
                  <Input 
                    placeholder="Digite o telefone"
                    maxLength={20}
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item>

                <Form.Item
                  name="email"
                  label="E-mail"
                  rules={[
                    { required: true, message: 'Campo obrigatório' },
                    { type: 'email', message: 'E-mail inválido' }
                  ]}
                >
                  <Input 
                    placeholder="Digite o e-mail"
                    maxLength={100}
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="endereco"
                  label="Endereço"
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                >
                  <Input.TextArea 
                    placeholder="Digite o endereço completo"
                    rows={3}
                    maxLength={255}
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item>

                <Form.Item
                  name="site"
                  label="Site"
                >
                  <Input 
                    placeholder="Digite o site (opcional)"
                    maxLength={100}
                    style={{ borderRadius: 6 }}
                    addonBefore="https://"
                  />
                </Form.Item>

                <Form.Item
                  name="img"
                  label="Logotipo da Empresa"
                >
                  <Dragger 
                    {...uploadProps}
                    style={{ 
                      borderRadius: 6,
                      border: '1px dashed rgba(0,0,0,0.1)'
                    }}
                  >
                    <div style={{ padding: 20, textAlign: 'center' }}>
                      {imageUrl ? (
                        <div style={{ position: 'relative' }}>
                          <Image
                            src={imageUrl}
                            style={{ 
                              maxHeight: 120,
                              maxWidth: '100%',
                              borderRadius: 4,
                              marginBottom: 8
                            }}
                            preview={false}
                          />
                          <div style={{ 
                            marginTop: 8,
                            color: primaryColor,
                            fontWeight: 500
                          }}>
                            <FaImage /> Nova imagem selecionada
                          </div>
                        </div>
                      ) : (
                        <>
                          <p className="ant-upload-drag-icon">
                            <FaImage style={{ 
                              fontSize: 32, 
                              color: primaryColor 
                            }} />
                          </p>
                          <p className="ant-upload-text" style={{ color: '#333' }}>
                            Clique ou arraste a imagem aqui
                          </p>
                          <p className="ant-upload-hint" style={{ color: 'rgba(0,0,0,0.5)' }}>
                            Formatos: JPG, PNG (máx. 2MB)
                          </p>
                        </>
                      )}
                    </div>
                  </Dragger>
                </Form.Item>

                {form.getFieldValue('img') && !imageUrl && (
                  <div style={{ textAlign: 'center' }}>
                    <p style={{ color: 'rgba(0,0,0,0.5)' }}>Imagem atual:</p>
                    <Image
                      width={150}
                      src={`${BASE_IMAGE_URL}${form.getFieldValue('img')}`}
                      style={{ 
                        borderRadius: 6,
                        border: '1px solid rgba(0,0,0,0.1)'
                      }}
                    />
                  </div>
                )}
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    </ConfigProvider>
  );
};

export default GerirEmpresa;